import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numeroCNS'
})
export class NumeroCNSPipe implements PipeTransform {
  transform(value: string, ...args: any[]): any {
    if (value != null && value.length === 6) {
        //Formato: 00.000.0
        return value.replace(/(\d{2})(\d{3})(\d{1})/g, '\$1.\$2\.\$3');
    }
    return value;
  }
}
